module.exports = __webpack_public_path__ + "public/images/logo_loyalty.b9c2e1709dc04fa548b18d3ea7ae0008.svg";